import util from 'util';

import React from 'react';
import * as MuiCore from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import {
    Checkbox,
    Link,
    Dialog,
    DialogActions,
    Button,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Typography, FormControlLabel,
    TextField, Divider
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as PortalActions from "./PortalActions";
import * as DataFormats from "./DataFormats";
import EmailValidator from "email-validator";

const styles = theme => ({
    underlineBox: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.54)',
        paddingBottom: 4,
    },

});


/*
 * Secure form for entering card data.
 *
 * Documentation: https://stripe.com/docs/stripe-js/react
 */
class AutoPayPrompt extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...this.initialState};
    }

    initialState = {
        autoPayExisting: this.props.autoPayExisting,
        addAutoPay: this.props.addAutoPay,
        closeAutoPayPrompt: false,
        showAutoPayPromptWindow: this.props.showAutoPayPromptWindow,
        closeAutoPayPromptConfirmed: null,
        selectedAccount: this.props.selectedAccount,
        selectedPaymentMethod: this.props.selectedPaymentMethod,
        closeAutoPaySuccess: false,
        autoPayEmail: "",
        autoPayEmailError: false,
        closeAutoPayActionSuccess: this.props.closeAutoPayActionSuccess,
        autoPaySuccessfullyUpdated: false,
        wasAutoPaySelected: false,
        webUser: this.props.webUser,
        autoPayChoiceLabel: "",
    }

    checkEmails = (email) => {
        if (!email) {
            return true;
        }

        let temp = email;
        let badEmail = false;
        temp = temp.replace(',', ';');

        let emails = temp.split(';');
        emails.forEach(email => {
            if (!EmailValidator.validate(email.trim())) {
                badEmail = true;
            }
        });

        return !badEmail;
    }

    clickEnroll = () => {
        if (this.checkEmails(this.state.autoPayEmail)) {
            this.closeAutoPayPromptConfirmed(this.state.selectedPaymentMethod.id, "Y");
        } else {
            this.setState({autoPayEmailError: true});
        }

    }
    clickUnEnroll = () => {
        this.closeAutoPayPromptConfirmed(this.state.selectedPaymentMethod.id, "N");
    }


    closeAutoPayPromptConfirmed = (paymethodId, autoPayFinalValue) => {
        let autoPayChar = 'N';
        if (autoPayFinalValue) {
            autoPayChar = autoPayFinalValue;
        }

        let theEmail = "";
        if (this.state.autoPayEmail == null) {
            theEmail = "";
        } else if (typeof this.state.autoPayEmail === 'object' && this.state.autoPayEmail !== null) {
            theEmail = this.state.autoPayEmail.name;
        } else {
            theEmail = this.state.autoPayEmail;
        }
        if (theEmail !== "") {
            this.props.selectedAccount.autoPayReceiptEmails = theEmail.toUpperCase().trim();
        }
            PortalActions.updateCardAutoPayFl(() => {
            this.setState({
                submitting: false,
                autoPaySuccessfullyUpdated: true,
                closeAutoPaySuccess: true,
                closeAutoPayPrompt: false,
                autoPayEmailError: false,
            });
        }, (error, message) => {
            this.setState({
                submitting: false,
                showError: true,
                errorMessage: message,
                closeAutoPaySuccess: false,
                closeAutoPayPrompt: false,
                autoPayEmailError: false,
            });
        }, paymethodId, autoPayChar, theEmail);
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    };

    /* All other information fields */
    handleChange = (event) => {
        this.setState({wasAutoPaySelected: true, addAutoPay: event.target.checked});
    }

    handleClose = () => {
        this.props.closeAutoPayActionSuccess();
    }

    handleDismiss = () => {
        this.props.closeAutoPayActionDismiss();
    }

    handleDismissSuccess = () => {
        this.props.closeAutoPayActionSuccess();
        // this.setState({closeAutoPaySuccess: false});
    }

    clearForm = () => {
        this.setState(this.initialState);
    }

    paymentMethodSelected = (paymentMethod) => {
        let obj = this.state.selectedAccount.paymentMethods.find(method => method.id == paymentMethod);
        this.setState({selectedPaymentMethod: obj});
    }

    render() {
        // eslint-disable-next-line
        const {classes, theme} = this.props;

        console.log('Autopay prompt render: ');
        console.log(this.props);
        console.log(this.state);
        console.log(this.state.selectedPaymentMethod.autoPayFl === "Y" && !this.props.isNewPaymentMethod);
        let emailList = [];
        // if (!this.props.showAutoPayPromptWindow) {
        //     return null;
        // }

        let chkId = 0;
        if (typeof this.state.selectedAccount.billEmailTxt === 'string' || this.state.selectedAccount.billEmailTxt instanceof String) {
            chkId++;
            emailList.push({"id": chkId, "name": this.state.selectedAccount.billEmailTxt})
        }
        if (typeof this.state.selectedAccount.autoPayReceiptEmails === 'string' || this.state.selectedAccount.autoPayReceiptEmails instanceof String) {
            chkId++;
            emailList.push({"id": chkId, "name": this.state.selectedAccount.autoPayReceiptEmails})
        }
        if (typeof this.state.webUser.email === 'string' || this.state.webUser.email instanceof String) {
            chkId++;
            emailList.push({"id": chkId, "name": this.state.webUser.email})
        }
        //Remove duplicates
        emailList = [...new Set(emailList)];

        return (
            <React.Fragment>
                {!this.state.autoPaySuccessfullyUpdated &&
                    <Dialog open={!this.state.closeAutoPayPrompt}>
                        {this.state.selectedPaymentMethod.autoPayFl === "N" &&
                            <DialogTitle>AutoPay Agreement</DialogTitle>
                        }
                        {this.state.selectedPaymentMethod.autoPayFl === "Y" &&
                            <DialogTitle>AutoPay Controls</DialogTitle>
                        }
                        <DialogContent>
                            {!this.props.isNewPaymentMethod &&
                            <MuiCore.Grid item xs={12} style={{display: 'flex'}}>
                                <MuiCore.FormControl fullWidth>
                                    <MuiCore.InputLabel>Payment Methods</MuiCore.InputLabel>
                                    <MuiCore.Select native
                                                    value={this.state.selectedPaymentMethod.id}
                                                    onChange={(event => this.paymentMethodSelected(event.target.value))}>
                                        {this.props.selectedAccount.paymentMethods.map(method => {
                                            let methodName = 'Unknown Type';
                                            if (method.methodType === 'ACH') {
                                                methodName = method.bankName + ' ' + method.maskedValue;
                                                if (method.verified === 'N') {
                                                    methodName = methodName + ' (unverified)';
                                                }
                                            }
                                            if (method.methodType === 'CARD') {
                                                methodName = method.cardBrand.toUpperCase() + ' ****' + method.maskedValue;
                                            }
                                            if (method.autoPayFl === "Y") {
                                                methodName = methodName + " (Autopay Enabled)"
                                            }
                                            if (method.methodType != 'ACHC') {
                                                return (
                                                    <option key={method.id} value={method.id}>
                                                        {methodName}
                                                    </option>);
                                            } else {
                                                return (null);
                                            }
                                        })}
                                    </MuiCore.Select>
                                </MuiCore.FormControl>
                            </MuiCore.Grid>
                            }
                            {this.state.selectedPaymentMethod.autoPayFl === "N" &&
                                <DialogContentText>
                                    I authorize <b>{this.state.selectedAccount.statementGroupName}</b> to electronically debit my account as payments become due.
                                    You may disable electronic payments at any time from this portal or by calling <b style={{whiteSpace: 'nowrap'}}>
                                    {DataFormats.phoneNumber(this.state.selectedAccount.statementGroupBillingPhone)}</b>.
                                </DialogContentText>
                            }
                            {!this.props.isNewPaymentMethod || (this.props.isNewPaymentMethod && this.state.selectedPaymentMethod.id) &&
                                <Divider/>
                            }
                            {this.state.selectedPaymentMethod.autoPayFl === "N" &&
                                <DialogContentText>
                                    You may also enter a list of a comma-separated email addresses to receive a receipt
                                    once a month when Auto Pay runs.
                                </DialogContentText>
                            }
                            {this.state.selectedPaymentMethod.autoPayFl === "N" &&
                                <DialogContentText>
                                    This email address field for Auto Pay will be shared by all Auto Pay Enrolled
                                    Payment Methods on your account.
                                </DialogContentText>
                            }
                            {this.state.selectedPaymentMethod.autoPayFl === "N" &&
                                <MuiCore.Grid item xs={12} style={{display: 'flex'}}>
                                    <MuiCore.FormControl fullWidth>
                                        <Autocomplete freeSolo options={emailList}
                                                      onChange={(event, newValue) => {
                                                          if (typeof newValue === 'object' && newValue !== null) {
                                                              this.setState({autoPayEmail: newValue.name})
                                                          } else if (newValue !== null) {
                                                              this.setState({autoPayEmail: newValue})
                                                          }
                                                      }}
                                                      onInputChange={(event, newValue) => {
                                                          if (typeof newValue === 'object' && newValue !== null) {
                                                              this.setState({autoPayEmail: newValue.name})
                                                          } else if (newValue !== null) {
                                                              this.setState({autoPayEmail: newValue})
                                                          }
                                                      }}
                                                      inputValue={this.state.autoPayEmail}
                                                      getOptionLabel={(option) => option.name}
                                                      renderInput={(params) => (<TextField
                                                          {...params}
                                                          label="Auto Pay Receipt Emails"
                                                          margin="normal"
                                                          variant="outlined"
                                                          error={this.state.autoPayEmailError}
                                                          inputProps={{ ...params.inputProps, maxLength: 500}}
                                                          InputProps={{
                                                              ...params.InputProps,
                                                              type: 'search'
                                                          }}
                                                          InputLabelProps={{ style: {backgroundColor: "white"}}}/>)}
                                        />
                                    </MuiCore.FormControl>
                                </MuiCore.Grid>
                            }
                        </DialogContent>
                        {((this.state.selectedPaymentMethod.autoPayFl === "Y" && !this.props.isNewPaymentMethod) || (this.state.selectedPaymentMethod.autoPayFl === "Y" && this.props.isNewPaymentMethod && this.state.selectedPaymentMethod.id))&&
                            <DialogActions>
                                <Button variant="contained" onClick={this.clickUnEnroll}>Disable
                                    AutoPay</Button>
                                <Button variant="contained" onClick={this.handleDismiss}>Close</Button>
                            </DialogActions>
                        }
                        {/*ACH Verify */}
                        {/*Auto Pay for ACH OR Existing AutoPay opened via AutoPay button */}
                        {(this.state.selectedPaymentMethod.autoPayFl === "N" && !this.props.isNewPaymentMethod) &&
                            <DialogActions>
                                <Button variant="contained" onClick={this.clickEnroll}>Enable AutoPay</Button>
                                <Button variant="contained" onClick={this.handleDismiss}>Close</Button>
                            </DialogActions>
                        }
                        {(this.props.isNewPaymentMethod && !this.state.selectedPaymentMethod.id) &&
                            <DialogContentText>
                                I authorize <b>PayTrustNow</b> on behalf
                                of <b>{this.state.selectedAccount.statementGroupName}</b> to electronically debit
                                my
                                account and, if necessary, electronically
                                credit my account to correct erroneous debits. This authorization may be
                                revoked
                                by calling customer service at <b
                                style={{whiteSpace: 'nowrap'}}>{DataFormats.phoneNumber(this.state.selectedAccount.statementGroupBillingPhone)}</b>.
                            </DialogContentText>
                        }
                    </Dialog>
                }
                {this.state.autoPaySuccessfullyUpdated &&
                    <Dialog open={this.state.closeAutoPaySuccess} onClose={this.handleClose}>
                        <DialogContent>
                            <Typography variant='h6' style={{textAlign: 'center', textWeight: 'bold'}}>
                                Auto Pay Successfully Updated
                            </Typography>
                            <Typography variant='body1' style={{marginTop: 20, textAlign: 'center'}}>
                                The auto pay status for this payment method has been updated in our systems.
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleDismissSuccess}>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                }
            </React.Fragment>
        );
    }
}

export default withStyles(styles, {withTheme: true})(AutoPayPrompt)